import { Component, OnInit, TemplateRef } from '@angular/core';
import { SharedService } from '../shared.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HeaderService } from './header.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
	user: any = null;
	username: any;
	bucketurl = environment.bucketUrl;
	dialogRef!: MatDialogRef<any>;

	constructor(private sharedService: SharedService, private router: Router, private toastr: ToastrService, public dialog: MatDialog, private headerService: HeaderService) { }

	ngOnInit(): void {
		const userData = this.sharedService.getSessionStorage('user');
		this.user = userData ? JSON.parse(userData) : null;
		this.username = this.user.first_name;
		setTimeout(() => {
      	  this.getMasters()
    	}, 0)
	}

	openDialog(logout_pop: TemplateRef<any>): void {
		this.dialogRef = this.dialog.open(logout_pop, {
			width: '400px',
		  })
	}

	closeDialog(): void {
		this.dialogRef.close();
	  }

	logOut() {
		this.dialogRef.close();
		sessionStorage.clear();
		this.router.navigate(['']);
		this.toastr.success('Logged out!');
	}
	
   getMasters() {
    this.headerService.getMasters().subscribe((response: any) => {
      let responseData: any = response.body
      if (responseData.responseCode == 200) {
        sessionStorage.setItem('masters', JSON.stringify(responseData.data));
      }
    })
   }
}
